'use strict';

angular.module('atex.art').controller('ArtImportCtrl',
  ['$scope', '$q', '$location', '$http', '$routeParams', 'Application', 'AuthenticationService',

    function($scope, $q, $location, $http, $routeParams, Application, AuthenticationService) {

      function importContent() {
        var deferred = $q.defer();

        AuthenticationService.getCurrentUser().then(function (currentUser) {
          var url = "/onecms/dam/content/import";
          $http({
            method: 'POST',
            url: url,
            params: {'ref': $scope.ref},
            headers: {
              'Content-Type': 'text/plain',
              'X-Auth-Token': currentUser.token
            }
          }).then(function (response) {
            deferred.resolve(response.data);
          }, function(error) {
            deferred.reject(error);
          });
        });
        return deferred.promise;
      }

      $scope.ref = $routeParams.ref;
      importContent().then( function (id) {
        $location.url("/edit/" + id + '?intent=web');
      }, function(error) {
        var errorInfo = atex.onecms.error.Error({
          origin: 'Contributor Tool Detail View Controller',
          type: 'importError',
          severity: atex.onecms.error.severities.NORMAL,
          cause: error.data.message
        });

        Application.currentErrorInfo = { error: errorInfo };
        $location.url("/error");
      });
    }
  ]);
